"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from "react";
import Link from "next/link";
import { useLivescoreState } from "@/views/livescore/state/LivescoreStateContext";
import { asCompetition } from "@/views/livescore/utils/livescore";
import { useLabels } from "@/lib/labels/LabelsProvider";
const SPORT_PREFIX: Record<string, string> = {
  football: "fb:c:",
  basketball: "bb:c:",
  tennis: "tn:c:",
  hockey: "hk:c:",
  "american-football": "af:c:"
};
const MAX_LEAGUES = 12;
interface TopLeaguesSidebarProps {
  /** Merged competition IDs across sports, from resolvePopularCompetitionIds(tenant). */
  competitionIds: string[];
  /** "sidebar" for desktop vertical list; "chips" for mobile horizontal strip. */
  layout: "sidebar" | "chips";
  /** Locale for the "more" link. */
  locale: string;
}
export function TopLeaguesSidebar(t0) {
  const $ = _c(44);
  const {
    competitionIds,
    layout,
    locale
  } = t0;
  const {
    sport,
    activeCompetitionId,
    setActiveCompetitionId,
    entities
  } = useLivescoreState();
  const labels = useLabels();
  let t1;
  bb0: {
    const prefix = SPORT_PREFIX[sport];
    if (!prefix) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[1] !== competitionIds || $[2] !== prefix) {
      let t3;
      if ($[4] !== prefix) {
        t3 = id => id.startsWith(prefix);
        $[4] = prefix;
        $[5] = t3;
      } else {
        t3 = $[5];
      }
      t2 = competitionIds.filter(t3).slice(0, MAX_LEAGUES);
      $[1] = competitionIds;
      $[2] = prefix;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    t1 = t2;
  }
  const filteredIds = t1;
  let t2;
  if ($[6] !== activeCompetitionId || $[7] !== setActiveCompetitionId) {
    t2 = id_0 => {
      setActiveCompetitionId(activeCompetitionId === id_0 ? null : id_0);
    };
    $[6] = activeCompetitionId;
    $[7] = setActiveCompetitionId;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const onClick = t2;
  if (filteredIds.length === 0) {
    return null;
  }
  if (layout === "chips") {
    let t3;
    if ($[9] !== activeCompetitionId || $[10] !== entities || $[11] !== filteredIds || $[12] !== onClick) {
      let t4;
      if ($[14] !== activeCompetitionId || $[15] !== entities || $[16] !== onClick) {
        t4 = id_1 => {
          const comp = asCompetition(entities, id_1);
          const active = activeCompetitionId === id_1;
          return <button key={id_1} type="button" onClick={() => onClick(id_1)} className={`shrink-0 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs border transition-colors cursor-pointer ${active ? "bg-primary text-primary-foreground border-primary" : "bg-card text-foreground border-border hover:bg-muted"}`}>{comp?.assets?.logo && <img src={comp.assets.logo} alt="" className="w-4 h-4 rounded-full" />}<span className="whitespace-nowrap">{comp?.name ?? id_1}</span></button>;
        };
        $[14] = activeCompetitionId;
        $[15] = entities;
        $[16] = onClick;
        $[17] = t4;
      } else {
        t4 = $[17];
      }
      t3 = filteredIds.map(t4);
      $[9] = activeCompetitionId;
      $[10] = entities;
      $[11] = filteredIds;
      $[12] = onClick;
      $[13] = t3;
    } else {
      t3 = $[13];
    }
    const t4 = `/${locale}/livescore`;
    let t5;
    if ($[18] !== labels.common.seeAll || $[19] !== t4) {
      t5 = <Link prefetch={false} href={t4} className="shrink-0 inline-flex items-center px-3 py-1.5 rounded-full text-xs border border-border text-muted-foreground hover:bg-muted transition-colors">{labels.common.seeAll}</Link>;
      $[18] = labels.common.seeAll;
      $[19] = t4;
      $[20] = t5;
    } else {
      t5 = $[20];
    }
    let t6;
    if ($[21] !== t3 || $[22] !== t5) {
      t6 = <div className="flex gap-2 overflow-x-auto pb-2 -mx-4 px-4 md:hidden">{t3}{t5}</div>;
      $[21] = t3;
      $[22] = t5;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    return t6;
  }
  const t3 = labels.livescore?.picker?.title ?? "Top Leagues";
  let t4;
  if ($[24] !== t3) {
    t4 = <h3 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground px-2 mb-2">{t3}</h3>;
    $[24] = t3;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  let t5;
  if ($[26] !== activeCompetitionId || $[27] !== entities || $[28] !== filteredIds || $[29] !== onClick) {
    let t6;
    if ($[31] !== activeCompetitionId || $[32] !== entities || $[33] !== onClick) {
      t6 = id_2 => {
        const comp_0 = asCompetition(entities, id_2);
        const active_0 = activeCompetitionId === id_2;
        return <li key={id_2}><button type="button" onClick={() => onClick(id_2)} className={`w-full flex items-center gap-2 px-2 py-1.5 rounded-md text-sm transition-colors cursor-pointer ${active_0 ? "bg-primary text-primary-foreground" : "text-foreground hover:bg-muted"}`}>{comp_0?.assets?.logo && <img src={comp_0.assets.logo} alt="" className="w-5 h-5 rounded-full" />}<span className="truncate">{comp_0?.name ?? id_2}</span></button></li>;
      };
      $[31] = activeCompetitionId;
      $[32] = entities;
      $[33] = onClick;
      $[34] = t6;
    } else {
      t6 = $[34];
    }
    t5 = filteredIds.map(t6);
    $[26] = activeCompetitionId;
    $[27] = entities;
    $[28] = filteredIds;
    $[29] = onClick;
    $[30] = t5;
  } else {
    t5 = $[30];
  }
  let t6;
  if ($[35] !== t5) {
    t6 = <ul className="space-y-0.5">{t5}</ul>;
    $[35] = t5;
    $[36] = t6;
  } else {
    t6 = $[36];
  }
  const t7 = `/${locale}/livescore`;
  let t8;
  if ($[37] !== labels.common.seeAll || $[38] !== t7) {
    t8 = <Link prefetch={false} href={t7} className="block px-2 py-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors">{labels.common.seeAll}</Link>;
    $[37] = labels.common.seeAll;
    $[38] = t7;
    $[39] = t8;
  } else {
    t8 = $[39];
  }
  let t9;
  if ($[40] !== t4 || $[41] !== t6 || $[42] !== t8) {
    t9 = <aside className="hidden md:block sticky top-below-nav-gap space-y-1">{t4}{t6}{t8}</aside>;
    $[40] = t4;
    $[41] = t6;
    $[42] = t8;
    $[43] = t9;
  } else {
    t9 = $[43];
  }
  return t9;
}